<template>
  <div class="popup-contain">
    <!-- For add appointment page -->
    <div
      class="save-event-contain"
      v-if="$router.history.current.fullPath !== '/contacts'"
    >
      <!-- Question -->
      <p>How would you like to save?</p>

      <!-- Only for this option -->
      <div class="save-this-event" @click.prevent.stop="addEventLocal(true)">
        Save for this appointment only
      </div>

      <!-- Fot the future option -->
      <div class="save-future-event" @click.prevent.stop="addEventLocal(false)">
        Save For Future
      </div>
    </div>

    <!-- For contacts page -->
    <div class="save-event-contain" v-else>
      <!-- Fot the future option -->
      <div class="save-future-event" @click.prevent.stop="addEventLocal(false)">
        Click to confirm
      </div>
    </div>

    <!-- Cancel button -->
    <div class="cancel-contain" @click.stop.prevent="hide">Cancel</div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AddEventPopup",
  props: {
    hide: Function, // Method to hide popup
    additionalFunction: {
      default: () => {},
      type: Function
    } // If there is any additional function that needs to be taken care of
  },
  methods: {
    ...mapActions("event", {
      addEvent: "addEvent" // Action for adding an event
    }),
    addEventLocal(value) {
      // Step 1: Add the new event
      this.addEvent(value);

      // Step 2: Run the additional function
      this.additionalFunction();

      // Step 3: Hide the popup
      this.hide();
    }
  }
};
</script>
